import { render, staticRenderFns } from "./m-video.vue?vue&type=template&id=5892163e&scoped=true"
import script from "./m-video.vue?vue&type=script&lang=js"
export * from "./m-video.vue?vue&type=script&lang=js"
import style0 from "./m-video.vue?vue&type=style&index=0&id=5892163e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892163e",
  null
  
)

export default component.exports